import { TweenLite } from "gsap";
import { Button } from "../../IO";
import { CreateElement, Geometry, Rect, Scale, SetStyles } from "../../MyHelpers";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { TranslatorView } from "../../TranslatorView";
import { ZIndex } from "../../ZIndex";
import { PanelParams } from "./IPanelFactory";
import { ButtonState, Panel } from "./panel";
import { Orientation } from "../../FitScreen";
import { SettingsIconMap } from "./IPopUpPanelIcons";
import { Money } from "../../api";

export class panelOnlineResponsive5btns1Line extends Panel {
    private languageView: TranslatorView = null;
    protected spinArrow: ImageResource = null;
    protected spinArrowDiv: HTMLElement;
    protected gamePath: string = "";

    protected responsiveView: HTMLElement

    public constructor(params: PanelParams) {
        super(params);

        this.backendSettings = params.backendSettings;
        this.resid = params.resid.Add("Panel-OnlineResponsive");
        this.resourcesBasePath = params.resourcesBasePath;
        this.audio = params.audio;
        this.translator = params.translator;

        this.systemContext = params.systemContext.CreateSubContext("Panel");

        this.idleAnim = this.systemContext.TimingContext().CreateInterval("idleAnim", 500, () => this.IdleAnim())
        this.languageView = new TranslatorView(this.resid);
        this.gamePath = Settings.ResourcesFolder + "multigame/slot/common/resources/";
    }



    public override SetMessage(message: string): void {
        //this.view.querySelector(".message").innerHTML = message;
        this.messageElem.textContent = message;
    }


    protected buttonBorder: Partial<CSSStyleDeclaration> = {
        border: `${Scale.X(16)}px solid gold`,
    };

    protected autoplayButtonBorder: Partial<CSSStyleDeclaration> = {
        border: `${Scale.X(16)}px solid red`//`${Scale.XYpx(4)} solid red`,
    };

    protected sideSpinButtonsSize = {
        width: "5",
        height: "5",
    };

    protected buyBonusTxt: HTMLElement;
    protected butAutoplayLabel: HTMLElement;
    protected popUpBtn: HTMLElement;
    // private linesMessage: TranslatedLocation;


    public override ConstructHtml() {
        let SvgIcon: Partial<CSSStyleDeclaration> =
        {
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: Scale.XYpx(6),
        }

        let cssLinear: Partial<CSSStyleDeclaration> = {
            borderWidth: Scale.XYpx(5),
            borderStyle: "solid",
            position: "relative",
            margin: "0px auto",
            bottom: Scale.Ypx(5),
            filter: `blur(${Scale.XYpx(2)})`,
            width: "80%",
            borderImage: this.ButtonBackground().linearColor
        };

        let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "column",
            //justifyContent: "flex-end",
        };

        let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "row",
            flexGrow: "1",
        };

        let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(100),
            width: Scale.Wpx(70),
        };

        let cssMenuInfoButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(40),
            width: Scale.Wpx(70),
        };

        let cssButton: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),

            border: `${Scale.XYpx(4)} solid gold`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",

            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            // height: "100%",//Scale.Hpx(100),

            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",

            //backgroundOrigin: "border-box",
            //backgroundClip: "content-box, border-box",
            background: "rgba(0, 0, 0,0.5)",
            paddingTop: Scale.Wpx(6),
        };

        let cssLabel: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(40),
            lineHeight: "0px",
            //color: "white",
            textAlign: "center",

            fontFamily: "NotoSansDisplay-Bold",
            fontWeight: "bold",
            color: "white",
            textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
        };

        let cssMessageValue: Partial<CSSStyleDeclaration> = {
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
            fontSize: Scale.fhpx(25),

            color: "white",
            textShadow: "0 0 10px black",
            background: "transparent",
        };
        //credits
        let cssCredit: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(60),
            // lineHeight: Scale.Hpx(80),
            textAlign: "center",
            height: "100%",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            color: "white",
            top: Scale.Ypx(25),
            textShadow: `0 0 ${Scale.XYpx(10)} black`,

        };
        //money
        let cssCurrency: Partial<CSSStyleDeclaration> = {
            // fontSize: Scale.fhpx(60),
            // textAlign: "center",
            // color: "yellow",
            // textShadow: `0 0 ${Scale.XYpx(10)} black`,
            // position: "relative",
            // top: Scale.Ypx(14),
            // left: Scale.Ypx(0),
            // margin: Scale.Ypx(0),
            fontSize: Scale.fhpx(60),
            // lineHeight: Scale.Hpx(80),
            textAlign: "center",
            height: "100%",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            color: "yellow",
            // top: Scale.Ypx(25),
            textShadow: `0 0 ${Scale.XYpx(10)} black`,



        }

        // /* #region Left column */
        // let leftCol = CreateElement("div", {
        //     classes: ["but-vertical-group", "but-group-value-collect"],
        //     parentToAppend: this.view,
        //     style: {
        //         ...cssVerticalGroup
        //     }
        // });

        //     this.butVolume = CreateElement("div", {
        //         classes: ["but-vol", "button"],
        //         parentToAppend: leftCol,
        //         style: {
        //             ...cssLeftRightButton,
        // 			...cssButton,
        // 			//borderRadius: Scale.XYpx(50),

        //         }
        //     });

        //         let butVolLabel = CreateElement("div", {
        //             classes: ["but-vol-value", "label"],
        //             parentToAppend: this.butVolume,
        //             style: {
        //                 ...cssLabel
        //             }
        //         });

        //     this.butDenom = CreateElement("div", {
        //         classes: ["but-denom", "button"],
        //         parentToAppend: leftCol,
        //         style: {
        //             ...cssLeftRightButton,
        //             ...cssButton
        //         }
        //     });

        //         this.denomElem = CreateElement("div", {
        //             classes: ["denom-value", "message-value"],
        //             parentToAppend: this.butDenom,
        //             style: {
        //                 ...cssMessageValue
        //             }
        //         });

        //             let butDenomDenom = CreateElement("div", {
        //                 classes: ["denom-denom"],
        //                 parentToAppend: this.denomElem
        //             });


        /* #endregion */

        //this.view.innerHTML += 
        // `
        // <!-- new panel -->
        // <div class="but-vertical-group but-group-value-collect">
        //     <div class="but-vol button">
        //         <span class="but-vol-value label">
        //         </span>
        //     </div>

        //     <!--
        //     <div class="but-collect button">
        //         <span class="but-collect-value label">COLLECT</span>
        //     </div>
        //     -->
        //     <div class="but-denom button">
        //         <div class="denom-value message-value"><span class="denom-denom"></span></div>
        //     </div>
        // </div>`


        // `<div class="but-horizontal-group but-left-group">
        //     <div class="but-vertical-group but-group-denom-balance">


        //         <div class="but-credit button">
        //             <div class="but-credit-label label">

        //             </div>
        //             <div class="but-credit-currency currency">
        //                 <span class="but-credit-currency-value">123,456.00</span>
        //                 <!--<span class="but-credit-currncy-icon"></span>-->
        //             </div>
        //             <div class="but-credit-credit credit">123456</div>

        //             <div class="linear"> </div>
        //         </div>
        //     </div>

        //     <div class="but-vertical-group but-group-lines-totalbet">
        //         <div class="but-lines button " style="border: hidden; box-shadow: none;">
        //             <div class="but-lines-value message-value"><span class="playinon"> </span>&nbsp;<span
        //                     class="selected-lines"></span>&nbsp;
        //                 <span class="lines"></span></div>
        //         </div>

        //         <div class="but-horizontal-group">

        //             <div class="but-totalbet button">

        //                 <div class="but-totalbet-label label"></div>
        //                 <div class="but-totalbet-currency currency">
        //                     <span class="but-totalbet-currency-value">123.00</span>
        //                     <!--<span class="but-totalbet-currency-symbol"></span>-->
        //                 </div>

        //                 <div class="but-totalbet-credit credit">123</div>
        //                 <div class="linear"> </div>

        //             </div>

        //             <div class="but-betperline button" style="visibility: hidden;">
        //                 <div class="but-betperline-label label"></div>
        //                 <div class="but-betperline-credit credit">123</div>
        //                 <div class="but-betperline-currency currency">
        //                     <span class="but-betperline-currency-value">123.00</span>
        //                     <!--<span class="but-betperline-currency-symbol"></span>-->
        //                 </div>
        //             </div>
        //         </div>
        //     </div>


        // </div>`;

        // LEFT GROUP
        let grpLeft = CreateElement("div", {
            classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
                ...cssVerticalGroup,
                //width: "100%"
            }
        });
        let btnLines = CreateElement("div", {
            classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
                // height: Scale.Hpx(80),
                //position: "relative",
                //left: "-224px",
                //background: "transparent",
                //...cssButton
                alignSelf: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }
        });

        this.linesDenomMessage = this.translator.Translate(() => this.translator.t.playingDenomOnLines(this.denom, this.lines));
        let btnLinesValue = CreateElement("div", {
            classes: ["but-lines-value", "message-value"],
            parentToAppend: btnLines,
            childToAppend: this.linesDenomMessage.location,
            style: {
                ...cssMessageValue,
                fontSize: Scale.fhpx(30),
                textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", "),
            }
        });

        let grpDenomBalance = CreateElement("div", {
            classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
                ...cssHorizontalGroup,
                //flexGrow: "1"
                justifyContent: "space-evenly",
            }
        });


        this.btnBalance = CreateElement("div", {
            classes: ["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
                position: "relative",
                alignSelf: "flex-end",
                //left: "80px",
                width: "100%",
                ...cssButton,

            }
        });
        let btnBalanceLabel = CreateElement("div", {
            classes: ["but-credit-label", "label"],
            parentToAppend: this.btnBalance,
            childToAppend: this.translator.Anchor(() => this.translator.t.balance),
            style: {
                ...cssLabel
            }
        });

        this.balanceCurrency = CreateElement("div", {
            classes: ["but-credit-currency", "currency"], parentToAppend: this.btnBalance, style: {
                ...cssCurrency
            }
        });
        let btnBalanceCurrencyValue = CreateElement("span", { classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00" });
        this.balanceCredits = CreateElement("div", {
            classes: ["but-credit-credit", "credit"], parentToAppend: this.btnBalance, innerHTML: "123456", style: {
                ...cssCredit,
                marginBottom: Scale.XYpx(-10),

            }
        });
        let btnBalanceLinear = CreateElement("div", {
            classes: ["linear"], parentToAppend: this.btnBalance, style: {
                ...cssLinear
            }
        });
        this.popUpBtn = CreateElement("div", {
            parentToAppend: grpDenomBalance,
            style: {
                ...cssButton,
                width: Scale.Wpx(240),
                alignSelf: "flex-end",

                // height: ""   
            }

            // mousedown: () => {
            //     this.ShowPopUp();
            // }
        })

        let popUpMenuBtnlabel = CreateElement("div",
            {
                classes: ["popup-menu", "options"],
                parentToAppend: this.popUpBtn,
                childToAppend: this.translator.Anchor(() => this.translator.t.optionsbtntxt),
                style: {
                    ...cssLabel,
                    marginBottom: Scale.Ypx(10),
                }

            });

        let settingsIconDiv = CreateElement("div", {
            parentToAppend: this.popUpBtn,
            innerHTML: SettingsIconMap['SettingsIcon2'],
            style: {
                ...SvgIcon,
                transform: "scale(0.75)",
            }
        })
        // let grpLinesTotalbet = CreateElement("div", {classes: ["but-vertical-group", "but-group-lines-totalbet"], parentToAppend: grpLeft, style: {
        //     ...cssVerticalGroup,
        //     justifyContent: "space-evenly"
        // }});

        // TODO some spans, not needed 
        // let grpTotalPerLine = CreateElement("div", {classes: ["but-horizontal-group"], parentToAppend: grpDenomBalance, style: {
        //     ...cssHorizontalGroup
        // }});

        {
            let butDenom = CreateElement("div", {
                classes: ["but-denom", "button"],
                // parentToAppend: grpDenomBalance, 
                style: {
                    //alignSelf: "flex-end",
                    //flexGrow: "1",
                    alignSelf: "flex-end",
                    position: "relative",
                    //left: "127px",
                    width: Scale.Wpx(122),
                    ...cssButton
                }
            });
            this.butDenom = butDenom;
            let butDenomLabel = CreateElement("div", {
                classes: ["but-denom-label", "label"],
                parentToAppend: butDenom,
                childToAppend: this.translator.Anchor(() => this.translator.t.denom),
                style: {
                    ...cssLabel
                }
            });
            this.totalBetCurrency = CreateElement("div", {
                classes: ["but-denom-currency", "currency"], parentToAppend: butDenom, childToAppend: this.translator.Anchor(() => this.translator.t.denomOneCredit), style: {
                    ...cssCurrency
                }
            });
            // TODO span
            this.denomElem = CreateElement("div", {
                classes: ["but-denom-credit", "credit"], parentToAppend: butDenom, innerHTML: "123", style: {
                    ...cssCredit
                }
            });
            let butDenomLinear = CreateElement("div", {
                classes: ["linear"], parentToAppend: butDenom, style: {
                    ...cssLinear
                }
            });
        }


        {
            // let btnTotalbet = CreateElement("div", {classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
            //     //alignSelf: "flex-end",
            //     //flexGrow: "1",
            //     alignSelf: "flex-end",
            //     position: "relative",
            //     //left: "127px",
            //     width: Scale.Wpx(122),
            //     ...cssButton
            // }});
            // this.butTotalBet = btnTotalbet;
            //     let btnTotalbetLabel = CreateElement("div", {
            //         classes: ["but-totalbet-label", "label"], 
            //         parentToAppend: btnTotalbet, 
            //         childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
            //         style: {
            //             ...cssLabel
            //         }
            //     });
            //     this.totalBetCurrency = CreateElement("div", {classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
            //         ...cssCurrency
            //     }});
            //         // TODO span
            //     this.totalBetCredits = CreateElement("div", {classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
            //         ...cssCredit
            //     }});
            //     let btnTotalbetLinear = CreateElement("div", {classes: ["linear"], parentToAppend: btnTotalbet, style: {
            //         ...cssLinear
            //     }});

            let btnPerLine = CreateElement("div", {
                classes: ["but-betperline", "button"],
                parentToAppend: grpDenomBalance,
                style: {
                    alignSelf: "flex-end",
                    flexGrow: "1",
                    ...cssButton,
                    display: "none",
                }
            });
            let btnPerLineLabel = CreateElement("div", {
                classes: ["but-betperline-label", "label"],
                parentToAppend: btnPerLine,
                childToAppend: this.translator.Anchor(() => this.translator.t.tline),
                style: {
                    ...cssLabel
                }
            });
            this.betCredits = CreateElement("div", {
                classes: ["but-betperline-credit", "credit"],
                parentToAppend: btnPerLine,
                innerHTML: "123",
                style: {
                    ...cssCredit
                }
            });
            this.betCurrency = CreateElement("div", {
                classes: ["but-betperline-currency", "currency"],
                parentToAppend: btnPerLine,
                style: {
                    ...cssCurrency
                }
            });
            // TODO span
        }

        //this.butTotalBet = this.view.querySelector(".but-totalbet");

        // this.view.innerHTML += `<div class="but-vertical-group">

        //     <div class="but-win button">
        //         <div class="but-win-label label"></div>
        //         <div class="but-win-currency currency">
        //             <span class="but-win-currency-value">123,456.00</span>
        //             <!--<span class="but-win-currncy-icon">MXN</span>-->
        //         </div>
        //         <div class="but-win-credit credit">999999</div>
        //         <div class="linear"></div>
        //     </div>
        // </div>`;



        let centerCol = CreateElement("div", {
            classes: ["but-vertical-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup,
                justifyContent: "end",
            }
        });

        let butWin = CreateElement("div", {
            classes: ["but-win", "button"],
            parentToAppend: centerCol,
            style: {
                position: "relative",
                ...cssButton,
                height: "",
                justifyContent: "center",
                minWidth: Scale.Wpx(400),
                // flexGrow: "1",
            }
        });

        this.freeRoundsRemainingText = this.translator.Translate(() => {

            let remaining = 0;

            if (this.freeRoundsStats) {
                remaining = this.freeRoundsStats.FreeRoundsNumber - this.freeRoundsStats.PlayedFreeRoundsNumber;
            }

            return this.translator.t.freerRoundCounterText(remaining)
        });
        this.freeRoundsRemaining = CreateElement("div", {
            classes: ["free-spins-remaining", "label"],
            parentToAppend: butWin,
            childToAppend: this.freeRoundsRemainingText.location,
            style: {
                fontSize: Scale.fhpx(30),
                lineHeight: "0px",
                position: "absolute",
                top: "-15px",
                alignSelf: "center",
                display: "none",
                //borderRadius: Scale.XYpx(16),

                //border: `${Scale.XYpx(4)} solid gold`,
                //borderStyle: "inset",

                margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                color: "white",
            }
        });

        let butWinLabel = CreateElement("div", {
            classes: ["but-win-label", "label"],
            parentToAppend: butWin,
            style: {
                fontSize: Scale.fhpx(30),
                lineHeight: "0px",
                ...cssLabel
            }
        });

        this.winCurrency = CreateElement("div", {
            classes: ["but-win-currency", "currency"],
            parentToAppend: butWin,
            style: {
                fontSize: Scale.fhpx(35),
                textAlign: "center",
                color: "yellow",
                textShadow: "0 0 10px black",
                position: "relative",
                top: Scale.Ypx(30),
            }
        });

        // let butWinCurrencyValue = CreateElement("span", {
        //     classes: ["but-win-currency-value"],
        //     parentToAppend: butWinCurrency
        // });

        this.winCredits = CreateElement("div", {
            classes: ["but-win-credit", "credit"],
            parentToAppend: butWin,
            style: {
                ...cssCredit,
                fontSize: Scale.fhpx(100),
                // lineHeight: Scale.Hpx(100),
                marginTop: Scale.Ypx(2),
            }
        });

        let butWinLinear = CreateElement("div", {
            classes: ["linear"],
            parentToAppend: butWin,
            style: {
                ...cssLinear,
                bottom: Scale.Ypx(14),

            }
        });





        // this.view.innerHTML += `
        // <div class="but-vertical-group but-group-autplay-maxbet-spin-messages but-right-group">
        //     <div class="but-message button message-value message" style="border: hidden; box-shadow: none;">
        //     </div>

        //     <div class="but-horizontal-group but-group-autoplay-maxbet-spin">
        //         <div class="but-horizontal-group but-group-autoplay-maxbet">
        //             <div class="but-auto-play button" style="visibility: hidden;">
        //                 <div class="but-auto-play-label label"></div>
        //             </div>

        //             <div class="but-max-bet button" style="position: relative; left: -100px;">
        //                 <div class="but-max-bet-label label"></div>
        //                 <div class="linear"> </div>
        //             </div>
        //         </div>


        //         <div class="but-spin button ">
        //             <div id="spindix" class="but-spin-label label"></div>
        //             <div class="linear"> </div>
        //         </div>
        //     </div>
        // </div>`;

        let grpRight = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-autplay-maxbet-spin-messages", "but-right-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup,
                //width: "100%",
            }
        });

        this.messageElem = CreateElement("div", {
            classes: ["but-message", "button", "message-value", "message"],
            parentToAppend: grpRight,
            style: {
                // height: Scale.Hpx(80),
                // position: "relative",
                //left: "-30px",
                //...cssButton,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: Scale.fhpx(30),
                color: "white",
                textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", "),
                background: "transparent",
            }
        });

        let grpRightHorizontal = CreateElement("div", {
            classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
            parentToAppend: grpRight,
            style: {
                ...cssHorizontalGroup,
                flexGrow: "1",
                justifyContent: "space-evenly",
            }
        });

        let grpAutoplayMaxbet = CreateElement("div", {
            classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
            parentToAppend: grpRightHorizontal,
            style: {
                ...cssHorizontalGroup,
                flexGrow: "0",
            }
        });

        // this.butAutoplay = CreateElement("div", 
        //     {
        //         classes: ["but-auto-play", "button"],
        //         parentToAppend: grpAutoplayMaxbet,
        //         style: {
        //             //flexGrow: "1",
        //             alignSelf: "flex-end",
        //             ...cssButton,
        //             //display: "none",
        //         }
        //     });

        // let butAutplayLabel = CreateElement("div", 
        //         {
        //             classes: ["but-auto-play-label", "label"],
        //             parentToAppend: this.butAutoplay,
        //             childToAppend: this.translator.Anchor(() => this.translator.t.auto),
        //             style: {
        //                 ...cssLabel,
        //                 fontSize: Scale.fhpx(18),

        //             }
        //         });

        let btnTotalbet = CreateElement("div", {
            classes: ["but-totalbet", "button"], parentToAppend: grpAutoplayMaxbet, style: {
                //alignSelf: "flex-end",
                //flexGrow: "1",
                alignSelf: "flex-end",
                position: "relative",
                //left: "127px",
                width: Scale.Wpx(150),
                ...cssButton,

            }
        });
        this.butTotalBet = btnTotalbet;
        let btnTotalbetLabel = CreateElement("div", {
            classes: ["but-totalbet-label", "label"],
            parentToAppend: btnTotalbet,
            childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
            style: {
                ...cssLabel
            }
        });
        this.totalBetCurrency = CreateElement("div", {
            classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
                ...cssCurrency
            }
        });
        // TODO span
        this.totalBetCredits = CreateElement("div", {
            classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, style: {
                ...cssCredit,
                marginBottom: Scale.XYpx(-10),

            }
        });
        let btnTotalbetLinear = CreateElement("div", {
            classes: ["linear"], parentToAppend: btnTotalbet, style: {
                ...cssLinear
            }
        });

        this.butMaxBet = CreateElement("div", {
            classes: ["but-max-bet", "button"],
            parentToAppend: grpAutoplayMaxbet,
            style: {
                //flexGrow: "1",
                alignSelf: "flex-end",
                ...cssButton,
                width: Scale.Wpx(150),
            }
        })

        let butMaxBetLabel = CreateElement("div", {
            classes: ["but-max-bet-label", "label"],
            parentToAppend: this.butMaxBet,
            childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
            style: {
                ...cssLabel,
                lineHeight: Scale.Hpx(40),
                textAlign: "center",
                color: "white",
                position: "relative",
                marginBottom: Scale.XYpx(-10),

                // top: Scale.Ypx(10),
            }
        });

        let butMaxBetLinear = CreateElement("div", {
            classes: ["linear"],
            parentToAppend: this.butMaxBet,
            style: {
                ...cssLinear,
                top: Scale.Ypx(12),
            }
        });
        // DoubleUp siempre visible al lado de Max Bet; se activa solo con ganancia (SetDoubleUpEnabled)
        this.butDoubleUp = CreateElement("div", {
            classes: ["but-double-up", "button"],
            parentToAppend: grpAutoplayMaxbet,
            style: {
                alignSelf: "flex-end",
                ...cssButton,
                width: Scale.Wpx(150),
            }
        });
        let butDoubleUpLabel = CreateElement("div", {
            classes: ["but-double-up-label", "label"],
            parentToAppend: this.butDoubleUp,
            childToAppend: this.translator.Anchor(() => this.translator.t.doubleUp),
            style: {
                ...cssLabel,
                lineHeight: Scale.Hpx(40),
                textAlign: "center",
                color: "white",
                position: "relative",
                marginBottom: Scale.XYpx(-10)
            }
        });
        let butDoubleUpLinear = CreateElement("div", {
            classes: ["linear"],
            parentToAppend: this.butDoubleUp,
            style: {
                ...cssLinear,
                top: Scale.Ypx(12),
            }
        });
        // let butAutoLinear = CreateElement("div", {
        //             classes: ["linear"],
        //             parentToAppend: this.butAutoplay,
        //             style: {
        //                 ...cssLinear,
        //                 textAlign: "center",   
        //                 top: Scale.Ypx(12),
        //             }
        //         });




        // +
        // `<div class="but-vertical-group but-group-help-games">
        //     <div class="but-help button">
        //         <div class="help-background">
        //             <div class="but-help-icon label">INFO</div>
        //         </div>
        //     </div>


        //     <div class="but-games button">
        //         <span class="but-games-icon label">MENU</span>
        //     </div>
        // </div>
        // `
        ;
        {
            let rightCol = CreateElement("div", {
                classes: ["but-vertical-group", "but-group-help-games"],
                parentToAppend: this.view,
                style: {
                    ...cssVerticalGroup
                }
            });
            this.butVolume = CreateElement("div", {
                classes: ["but-vol", "button"],
                // parentToAppend: rightCol,
                style: {
                    ...cssLeftRightButton,
                    ...cssButton,
                    //borderRadius: Scale.XYpx(50),

                }
            });

            let butVolLabel = CreateElement("div", {
                classes: ["but-vol-value", "label"],
                parentToAppend: this.butVolume,
                style: {
                    ...cssLabel
                }
            });
        }

        {
            let rightCol = CreateElement("div", {
                classes: ["but-vertical-group", "but-group-help-games"],
                // parentToAppend: this.view,
                style: {
                    ...cssVerticalGroup
                }
            });
            this.butHelp = CreateElement("div", {
                classes: ["but-help", "button"],
                parentToAppend: rightCol,
                style: {
                    ...cssButton,
                    ...cssMenuInfoButton,
                }
            });

            let butHelpBack = CreateElement("div", {
                classes: ["help-background"],
                parentToAppend: this.butHelp
            });

            let butHelpLabel = CreateElement("div", {
                classes: ["but-help-icon", "label"],
                parentToAppend: butHelpBack,
                innerHTML: "INFO",
                style: {
                    ...cssLabel
                }
            });

            this.butMenu = CreateElement("div", {
                classes: ["but-games", "button"],
                parentToAppend: rightCol,
                style: {

                    ...cssButton,
                    ...cssMenuInfoButton,
                    overflow: "hidden",
                    display: "block",
                    //flexGrow : "0"
                }
            });


        }



        // Pantalla grande: botones a la derecha (layout original). Responsivo: OnResize los coloca bajo rieles, encima del panel.
        this.responsiveView = CreateElement("div", {
            classes: ["panel-responsive-view"],
            style: {
                position: "absolute",
                right: "0px",
                top: "0px",
                width: "10%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: ZIndex.ResponsivePanel.toString(),
            }
        });
        this.btnChangeBetType = CreateElement("div", {
            classes: ["but-buy-bonus", "button"],
            parentToAppend: this.responsiveView,
            style: {
                width: this.sideSpinButtonsSize.width + "vw",
                height: this.sideSpinButtonsSize.height + "vw",
                position: "relative",
                borderRadius: "50%",
                aspectRatio: "1/1",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                transform: "rotate(90deg)",
                background: `${this.panelColors.backgroundButtonColor}`,
                border: `${Scale.W(16)}px solid gold`,
            },
        });

        this.betTypeLabel = CreateElement("div", {
            classes: ["but-bet-type"],
            parentToAppend: this.btnChangeBetType,
            childToAppend: this.translator.Anchor(() => this.translator.t.buyBonusButton),
            style: {
                ...this.cssLabel,
                rotate: "-90deg",
                lineHeight: Scale.Hpx(45)
            },
        });

        this.butSpin = CreateElement("div", {
            classes: ["but-spin", "button"],
            parentToAppend: this.responsiveView,
            style: {
                width: "10vw",
                alignSelf: "flex-end",
                position: "relative",
                height: "10vw",
                borderRadius: "50%",
                aspectRatio: "1/1",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                transform: "rotate(90deg)",
                background: `${this.panelColors.backgroundButtonColor}`,
                border: `${Scale.W(16)}px solid gold`,
            }
        });

        this.spinArrowDiv = CreateElement("div", {
            classes: ["but-spin-arrow", "arrow"],
            parentToAppend: this.butSpin,
            style: {
                backgroundImage: this.spinArrow.CssBackground(),
                height: '100%',
                width: '100%',
                position: "absolute",
                placeContent: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
            }
        });

        this.butAutoplay = CreateElement("div",
            {
                classes: ["but-auto-play", "button"],
                parentToAppend: this.responsiveView,
                style: {
                    width: this.sideSpinButtonsSize.width + "vw",
                    height: this.sideSpinButtonsSize.height + "vw",
                    position: "relative",
                    borderRadius: "50%",
                    aspectRatio: "1/1",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    transform: "rotate(90deg)",
                    background: `${this.panelColors.backgroundButtonColor}`,
                    border: `${Scale.W(16)}px solid gold`,
                }
            });

        this.butAutoplayLabel = CreateElement("div",
            {
                classes: ["but-auto-play-label", "label"],
                parentToAppend: this.butAutoplay,
                childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                style: {
                    ...this.cssLabel,
                    rotate: "-90deg",
                    lineHeight: Scale.Hpx(45),
                }
            });

        this.HideBuyBonus();
    }

    private HideBuyBonus(): void {
        if (!this.buyBonusIsEnabledForAny) {
            this.btnChangeBetType.style.visibility = "hidden";
        }
    }
    protected override AnimateButtonPress(buttonState: ButtonState, pressed: boolean): void {
        if (pressed) {
            if (buttonState.button == Button.ButtonSpin && this.spinArrowDiv) {
                TweenLite.fromTo(this.spinArrowDiv, 1, { rotation: 0 }, { rotation: 720 });
                //this.spinCircleSmallArrowDiv.style.backgroundColor="#FF0000";
            }
        }
    }

    protected override IdleAnim() {
    }

    public override async PrepareResources(resourceManager: ResourceManager): Promise<void> {
        super.PrepareResources(resourceManager);
        //Language View
        await this.languageView.PrepareResources(resourceManager);
        resourceManager.Add(new ImageResource(this.gamePath + "arrow.png", this.resid.ScopedResourceName(["arrow", "cycle"])));//New Element
    }

    public override async ResourcesLoaded(resourceManager: ResourceManager): Promise<void> {

        this.spinArrow = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["arrow", "cycle"]));//New Element

        this.view = CreateElement("div", {
            classes: ["panel", this.resid.Scope()],
            style: {

                //border: "5px solid blue",
                boxSizing: "border-box",

                width: "100vh",
                minHeight: Scale.Hpx(150),
                // width: Scale.Wpx(1575),
                // height: Scale.Hpx(160),

                fontFamily: "NotoSansDisplay-Bold",
                fontWeight: "bold",

                display: "flex",
                justifyContent: "center",

                transformOrigin: "bottom",
                zIndex: ZIndex.Panel.toString(),
                // padding: Scale.XYpx(40),

                //position: "absolute",

            }
        });

        this.ConstructHtml();

        this.ConstructButton(Button.ButtonSettings, this.popUpBtn);
        this.ConstructButton(Button.ButtonSpin, this.butSpin);
        this.ConstructButton(Button.ButtonCreditsMoney, this.btnBalance);

        this.ConstructButton(Button.ButtonBetNext, this.butTotalBet);
        this.ConstructButton(Button.ButtonHelp, this.butHelp, 500);
        this.ConstructButton(Button.ButtonVolumeNext, this.butVolume);
        this.ConstructButton(Button.ButtonAutoplay, this.butAutoplay);
        this.ConstructButton(Button.ButtonMaxBet, this.butMaxBet);
        this.ConstructButton(Button.ButtonDenomMenu, this.butDenom, 500);
        this.ConstructButton(Button.ButtonDoubleUp, this.butDoubleUp, 500);
        this.SetDoubleUpEnabled(false);

        if (this.buyBonusIsEnabledForAny) {
            this.ConstructButton(Button.ButtonChangeBetType, this.btnChangeBetType);
        }
        // this.volume0 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume0", "image"]));
        // this.volume1 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume1", "image"]));
        // this.volume2 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume2", "image"]));
        // this.volume3 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume3", "image"]));


        this.audio.OnVolumeChange((volumeLevel: number, volumeFactor: number) => this.OnVolumeChange(volumeLevel, volumeFactor));

        //language flag
        await this.languageView.ResourcesLoaded(resourceManager);

        this.butMenu.appendChild(this.languageView.View());

        this.AutoPlayLoaded();
    }


    protected override AutoPlayPrepare(): void {
    }

    protected override AutoPlayLoaded() {
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem) {
            this.autoPlayTimer = this.systemContext.TimingContext().CreateInterval("autoplay", 250, () => {
                if (this.autoPlayColor == "red") {
                    this.autoPlayColor = "transparent";
                    SetStyles(autoPlayButtonElem, this.buttonBorder);
                }
                else {
                    this.autoPlayColor = "red";
                    SetStyles(autoPlayButtonElem, this.autoplayButtonBorder);
                }
            });
        }
    }

    public override AutoplayEnable(): void {
        this.autoPlayTimer?.Start();
    }

    public override AutoplayDisable(): void {
        this.autoPlayTimer?.Stop();
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem) {
            SetStyles(autoPlayButtonElem, this.buttonBorder);
            //autoPlayButtonElem.style.borderColor = "transparent"
        }

    }
    public override OnVolumeChange(volumeLevel: number, volumeFactor: number): void {

    }
    public override SpinButtonLabelChange(state: string): void { }
    protected override IdleAnimStop() {
        this.idleAnim.Stop();

        // off
        this.idleAnimState = false;
    }

    public ResponsiveView() {
        return this.responsiveView;
    }

    public override ChangeTotalBet(totalCredit: string, totalCurrency: string, totalBet: Money): void {
        this.totalBet = totalBet;
        //this.totalBetCredits.textContent = totalCredit;
        //this.totalBetCurrency.textContent = totalCurrency;
        this.totalBetCreditsValue = totalCredit;
        this.totalBetCurrencyValue = totalCurrency;

        if (!this.switched) {
            this.totalBetCredits.textContent = this.totalBetCurrencyValue;
            this.totalBetCurrency.textContent = "";//this.totalBetCreditsValue;
        }
        else {
            this.totalBetCredits.textContent = this.totalBetCreditsValue;
            this.totalBetCurrency.textContent = "";//this.totalBetCurrencyValue;
        }

        this.UpdateFreeRoundsStats();
    }

    public override SetBalance(totalBalanceCredit: string, totalBalanceCurrency: string,): void {
        this.balanceCreditValue = totalBalanceCredit;
        this.balanceCurrencyValue = totalBalanceCurrency;

        //Only currency
        if (!this.switched) {
            this.balanceCredits.textContent = this.balanceCurrencyValue;
            this.balanceCurrency.textContent = "";//this.balanceCreditValue;
            this.balanceCredits.style.color = "yellow";

            
            this.winCredits.textContent = this.winCurrencyValue;
            this.winCurrency.textContent = "";//this.winCreditsValue;
            this.winCredits.style.color = "yellow";

            
            this.totalBetCredits.textContent = this.totalBetCurrencyValue;
            this.totalBetCurrency.textContent = "";//this.totalBetCreditsValue;
            this.totalBetCredits.style.color = "yellow";
        }
        else {
            this.balanceCredits.textContent = this.balanceCreditValue;
            this.balanceCurrency.textContent = "";//this.balanceCurrencyValue;
            this.balanceCredits.style.color = "white";

            this.winCredits.textContent = this.winCreditsValue;
            this.winCurrency.textContent = "";//this.winCurrencyValue;
            this.winCredits.style.color = "white";

            this.totalBetCredits.textContent = this.totalBetCreditsValue;
            this.totalBetCurrency.textContent = "";//this.totalBetCurrencyValue;
            this.totalBetCredits.style.color = "white";
        }
    }

    public override SetBet(betCredit: string, betCurrency: string, bet: Money): void {
        this.totalBet = bet;
        this.betCredits.textContent = betCredit;
        this.betCurrency.textContent = betCurrency;

        if (!this.switched) {

            this.totalBetCredits.textContent = this.totalBetCurrencyValue;
            this.totalBetCurrency.textContent = "";//this.totalBetCreditsValue;
            return;
        }

        this.totalBetCredits.textContent = this.totalBetCreditsValue;
        this.totalBetCurrency.textContent = "";//this.totalBetCurrencyValue;

    }

    public override ToggleCreditMoney() {
        this.switched = !this.switched;

        //Only currency
        if (!this.switched) {
            this.balanceCredits.textContent = this.balanceCurrencyValue;
            this.balanceCurrency.textContent = "";//this.balanceCreditValue;
            this.balanceCredits.style.color = "yellow";

            this.winCredits.textContent = this.winCurrencyValue;
            this.winCurrency.textContent = "";//this.winCreditsValue;
            this.winCredits.style.color = "yellow";

            this.totalBetCredits.textContent = this.totalBetCurrencyValue;
            this.totalBetCurrency.textContent = "";//this.totalBetCreditsValue;
            this.totalBetCredits.style.color = "yellow";
        }
        else {
            this.balanceCredits.textContent = this.balanceCreditValue;
            this.balanceCurrency.textContent = "";//this.balanceCurrencyValue;
            this.balanceCredits.style.color = "white";

            this.winCredits.textContent = this.winCreditsValue;
            this.winCurrency.textContent = "";//this.winCurrencyValue;
            this.winCredits.style.color = "white";

            this.totalBetCredits.textContent = this.totalBetCreditsValue;
            this.totalBetCurrency.textContent = "";//this.totalBetCurrencyValue;
            this.totalBetCredits.style.color = "white";
        }
    }

    public override SetWin(totalWinCredit: string, totalWinCurrency: string): void {
        //this.winCredits.textContent = totalWinCredit;
        //this.winCurrency.textContent = totalWinCurrency;
        this.winCreditsValue = totalWinCredit;
        this.winCurrencyValue = totalWinCurrency;

        if (!this.switched) {
            this.winCredits.textContent = this.winCurrencyValue;
            this.winCurrency.textContent = "";//this.winCreditsValue;
        }
        else {

            this.winCredits.textContent = this.winCreditsValue;
            this.winCurrency.textContent = "";//this.winCurrencyValue;
        }
    }

    /** Último estado de layout: pantalla pequeña (true) o grande (false). */
    private lastIsSmallScreen: boolean = null;
    /** Ancho por debajo del cual se usa layout "spin bajo rieles, luego panel" (pantallas pequeñas). */
    private static readonly SMALL_SCREEN_WIDTH_PX = 768;
    public override OnResize(w: number, h: number, orientation: Orientation) {

        this.balanceCredits.style.color = "yellow";
        this.winCredits.style.color = "yellow";
        this.totalBetCredits.style.color = "yellow";

        const isSmallScreen =
            orientation === Orientation.Portrait ||
            (typeof window !== "undefined" && window.innerWidth < panelOnlineResponsive5btns1Line.SMALL_SCREEN_WIDTH_PX);

        // Aplicar siempre el layout según tamaño actual (así al pasar de pequeña a grande se restaura la posición)
        if (!isSmallScreen) {
            // Pantalla grande: botones a la derecha, centrados en la columna (layout original)
            this.responsiveView.style.left = "";
            this.responsiveView.style.bottom = "";
            this.responsiveView.style.right = "0px";
            this.responsiveView.style.top = "0px";
            this.responsiveView.style.width = "10%";
            this.responsiveView.style.height = "100%";
            this.responsiveView.style.flexDirection = "column";
            this.responsiveView.style.justifyContent = "center";
            this.responsiveView.style.alignItems = "center";
            this.responsiveView.style.gap = "";
            this.responsiveView.style.padding = "";
            this.responsiveView.style.minHeight = "";
            this.responsiveView.style.maxHeight = "";

            this.butSpin.style.width = "10vw";
            this.butSpin.style.height = "10vw";
            this.butSpin.style.transform = "rotate(90deg)";
            this.butSpin.style.alignSelf = "flex-end";
            this.btnChangeBetType.style.width = this.sideSpinButtonsSize.width + "vw";
            this.btnChangeBetType.style.height = this.sideSpinButtonsSize.height + "vw";
            this.btnChangeBetType.style.transform = "rotate(90deg)";
            this.butAutoplay.style.width = this.sideSpinButtonsSize.width + "vw";
            this.butAutoplay.style.height = this.sideSpinButtonsSize.height + "vw";
            this.butAutoplay.style.transform = "rotate(90deg)";

            this.betTypeLabel.style.rotate = "-90deg";
            this.betTypeLabel.style.transform = "";
            this.betTypeLabel.style.fontSize = "";
            this.butAutoplayLabel.style.rotate = "-90deg";
            this.butAutoplayLabel.style.transform = "";
            this.butAutoplayLabel.style.fontSize = "";

            this.view.style.marginBottom = "";
        } else {
            // Modo responsivo: botones abajo, pegados al panel (evitar que suban hacia los rieles; usar espacio hacia abajo)
            this.responsiveView.style.right = "";
            this.responsiveView.style.top = "";
            this.responsiveView.style.left = "0px";
            this.responsiveView.style.bottom = "5%";
            this.responsiveView.style.width = "100%";
            this.responsiveView.style.height = "14vh";
            this.responsiveView.style.minHeight = "56px";
            this.responsiveView.style.maxHeight = "120px";
            this.responsiveView.style.flexDirection = "row";
            this.responsiveView.style.justifyContent = "center";
            this.responsiveView.style.alignItems = "center";
            this.responsiveView.style.gap = "clamp(4px, 2vw, 20px)";
            this.responsiveView.style.padding = "0 clamp(4px, 1.5vw, 12px)";
            this.responsiveView.style.boxSizing = "border-box";

            // Tamaños que caben en móviles estrechos sin solaparse; alinear Spin con Buy Bonus y Auto Play
            this.butSpin.style.width = "clamp(40px, 11vmin, 88px)";
            this.butSpin.style.height = "clamp(40px, 11vmin, 88px)";
            this.butSpin.style.transform = "";
            this.butSpin.style.alignSelf = "center";
            this.butSpin.style.boxSizing = "border-box";
            this.btnChangeBetType.style.width = "clamp(36px, 9.5vmin, 72px)";
            this.btnChangeBetType.style.height = "clamp(36px, 9.5vmin, 72px)";
            this.btnChangeBetType.style.transform = "";
            this.btnChangeBetType.style.boxSizing = "border-box";
            this.butAutoplay.style.width = "clamp(36px, 9.5vmin, 72px)";
            this.butAutoplay.style.height = "clamp(36px, 9.5vmin, 72px)";
            this.butAutoplay.style.transform = "";
            this.butAutoplay.style.boxSizing = "border-box";

            this.betTypeLabel.style.rotate = "";
            this.betTypeLabel.style.transform = "";
            this.betTypeLabel.style.fontSize = "clamp(10px, 2.5vmin, 20px)";
            this.butAutoplayLabel.style.rotate = "";
            this.butAutoplayLabel.style.transform = "";
            this.butAutoplayLabel.style.fontSize = "clamp(10px, 2.5vmin, 20px)";

            this.view.style.marginBottom = Scale.Hpx(8);
        }

        if (isSmallScreen !== this.lastIsSmallScreen) {
            this.lastIsSmallScreen = isSmallScreen;
            this.HideBuyBonus();
        }
    }
}
